import { render, staticRenderFns } from "./ContractEvents.yaml?vue&type=template&id=8bcee530&component"
import script from "./ContractEvents.yaml?vue&type=script&lang=ts&component"
export * from "./ContractEvents.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports